const markers =  {
    PRIZEMIE: [
        {
            title: "Herňa materskej školy",
            position: [1100, 400],
            img: 'herna1.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba1.jpg", 
                    position: [2000, -200, -2600]
                }
            ] 
        },
        {
            title: "Jedáleň",
            position: [1100, 1400],
            img: 'jedalen.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba1.jpg", 
                    position: [2500, -200, 750]
                }
            ] 
        },
        {
            title: "Kuchyňa",
            position: [1100, 2100],
            img: 'kuchyna.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba1.jpg", 
                    position: [1100, -200, 2000]
                }
            ] 
        },
        {
            title: "Chodba",
            position: [1500, 1150],
            img: 'chodba1.jpg',
            infospots: [
                {
                    title: "Herňa materskej školy",
                    target: "herna1.jpg", 
                    position: [-1000, -200, 4000]
                },
                {
                    title: "Jedáleň",
                    target: "jedalen.jpg", 
                    position: [-1500, -200, -500]
                },
                {
                    title: "Kuchyňa",
                    target: "kuchyna.jpg", 
                    position: [-600, -200, -3000]
                },
                {
                    title: "1. poschodie",
                    target: "chodba2.jpg", 
                    position: [600, -200, -2000]
                },
            ] 
        },
    ],
    POS1: [
        {
            title: "Chodba",
            position: [1550, 1550],
            img: 'chodba2.jpg',
            infospots: [
                {
                    title: "Školský klub",
                    target: "klub.jpg", 
                    position: [150, -200, -2500]
                },
                {
                    title: "Učebňa 1",
                    target: "ucebna1.jpg", 
                    position: [-800, -200, -2500]
                },
                {
                    title: "Počítačová učebňa",
                    target: "pc.jpg", 
                    position: [-150, -200, 2800]
                },
                {
                    title: "Učebňa 2",
                    target: "ucebna2.jpg", 
                    position: [-1000, -200, 2800]
                },
                {
                    title: "Prízemie",
                    target: "chodba1.jpg", 
                    position: [2000, -1000, 300]
                },
                {
                    title: "Učebňa materskej školy",
                    target: "herna2.jpg", 
                    position: [2000, -400, -500]
                },
                {
                    title: "Cvičebňa",
                    target: "cvicebna.jpg", 
                    position: [2000, -1000, -500]
                }
                ,
                {
                    title: "Spálňa materskej školy",
                    target: "spalna.jpg", 
                    position: [2000, 200, -500]
                }
            ] 
        },
        {
            title: "Počítačová učebňa",
            position: [1800, 450],
            img: 'pc.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [3000, -200, -1500]
                }
            ] 
        },
        {
            title: "Učebňa 1",
            position: [1150, 2400],
            img: 'ucebna1.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [2600, -200, -1800]
                }
            ] 
        },
        {
            title: "Učebňa 2",
            position: [1150, 650],
            img: 'ucebna2.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [2000, -200, -2900]
                }
            ] 
        },
        {
            title: "Školský klub",
            position: [1800, 2600],
            img: 'klub.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [3000, -200, 1200]
                }
            ] 
        }
    ],
    POS2: [
        {
            title: "Učebňa materskej školy",
            position: [1840, 670],
            img: 'herna2.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [900, -200, 2800]
                }
            ] 
        },
        {
            title: "Cvičebňa",
            position: [1180, 2180],
            img: 'cvicebna.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [1500, -200, 2700]
                }
            ] 
        },
        {
            title: "Spálňa materskej školy",
            position: [1180, 800],
            img: 'spalna.jpg',
            infospots: [
                {
                    title: "Chodba",
                    target: "chodba2.jpg", 
                    position: [2000, -200, 1000]
                }
            ] 
        },
    ],
};

export default markers